import { render, staticRenderFns } from "./ChangePushLink.vue?vue&type=template&id=54279a68&scoped=true"
import script from "./ChangePushLink.vue?vue&type=script&lang=js"
export * from "./ChangePushLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54279a68",
  null
  
)

export default component.exports